<template>
  <div class="form-floating mb-4">
    <currency-input
      ref="uiAmount"
      description="actual amount"
      elementId="statePensionAmount"
      @entered="onSaveClicked"
      :maxValue="15000"
    />
  </div>

  <p class="my-3 text-danger" v-show="showValidation">
    <i class="bi bi-x-circle-fill"></i>
    Amount not valid.
  </p>

  <bad-response-viewer ref="badResponseViewer" />

  <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
    <button
      type="button"
      class="btn btn-link text-dark text-decoration-none me-md-2"
      aria-label="Close"
      v-on:click="onCancelClicked"
    >
      Cancel
    </button>

    <button
      type="button"
      class="btn px-5 btn-secondary"
      v-on:click="onSaveClicked"
    >
      Update
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { inputValidator } from "@/db/ts/inputValidator";
import Constants from "@/guiide/ts/constants";
import CurrencyInput from "../../../shared/components/CurrencyInput.vue";
import BadResponseViewer from "../../../shared/components/BadResponseViewer.vue";
import { formatter } from "../../../db/ts/formatter";
import ResponseTracker from "@/shared/ts/responseTracker";
import { app } from "../../ts/app";
import { MessageResponse } from "@/guiide/ts/response/messageResponse";

export default defineComponent({
  name: "StatePensionEditor",
  emits: ["edit-finished"],
  components: {
    CurrencyInput,
    BadResponseViewer
  },
  setup() {
    const uiAmount = ref(null);
    const flagInvalidAnswer = ref(false);
    const badResponseViewer = ref(null);

    return {
      uiAmount,
      flagInvalidAnswer,
      badResponseViewer
    };
  },
  data() {
    return {
      inputValidator,
      formatter,
      responseTracker: ResponseTracker.empty<MessageResponse>()
    };
  },
  computed: {
    showValidation: function() {
      return this.flagInvalidAnswer;
    }
  },
  methods: {
    setValues(amount: number) {
      this.badResponseViewer.clear();
      this.uiAmount.setValue(amount);
    },
    onCancelClicked: function() {
      this.editIsFinished();
    },
    onSaveClicked: async function() {
      if (!this.uiAmount.validate()) {
        return;
      }

      const actualAmount = this.uiAmount.getValue();
      const responseTracker = await app.updateStatePension(actualAmount);

      if (responseTracker.isOk) {
        this.editIsFinished();
      } else {
        if (responseTracker.trackerWillHandleFailure) {
          responseTracker.handleFailure();
        } else {
          if (responseTracker.trackerWillHandleFailure) {
            responseTracker.handleFailure();
          } else {
            this.badResponseViewer.update(
              responseTracker.isOk,
              responseTracker.message
            );
          }
        }
      }
    },
    editIsFinished() {
      this.uiAmount.hideAnyWarnings();
      this.$emit("edit-finished");
    }
  }
});
</script>

<style>


</style>
